import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Box from '@mui/material/Box';
import TopBar from '@/components/common/top-bar/top-bar';
import { CheckForApplicationUpdate, useAuthenticated } from 'react-admin';

interface Props {
    children?: any;
}

const Layout = ({ children }: Props) => {
    useAuthenticated();

    return (
        <Box
            sx={{
                display: 'grid',
                height: '100vh',
                gridTemplateRows: 'auto 1fr',
            }}
        >
            <TopBar />

            <Box
                sx={{
                    p: 1,
                    height: '100%',
                    overflowY: 'auto',
                }}
            >
                {children}
            </Box>

            <CheckForApplicationUpdate />
            {import.meta.env.DEV && <ReactQueryDevtools buttonPosition="bottom-left" />}
        </Box>
    );
};

export default Layout;
